<template>
  <section class="ml-2 pl-0 info w-100 col-sm-12">
    <main class="main animated fadeIn faster" :class="{ 'expand-main': isMenuCollapse }">
      <LoadingSpinner v-if="loading" />
      <div class="container-fluid" v-if="!loading">
        <div class="row">
          <div class="col-12">
            <h3 v-if="selectedUserId != null" class="mt-2 font-weight-bold">Synthèses de traitement des objections</h3>
            <h1 v-else>Booker Daily Report</h1>
          </div>
        </div>

        <!-- Acordeones dinámicos -->
        <div class="mb-2" id="accordion">
          <div class="card mt-2" v-for="(item, index) in reports" :key="index">

            <div class="card-header p-0 d-flex align-items-center" :id="'heading-' + index">
              <button class="btn btn-link w-80 text-left" type="button" data-toggle="collapse"
                :data-target="'#collapse-' + index" aria-expanded="false" :aria-controls="'collapse-' + index">
                {{ item.date_sintesis }}
              </button>
              <div class="w-100">
                <button class="btn btn-sm btn-success float-right mr-3" @click="showPrompt(item.date_sintesis)">Show
                  prompt</button>
              </div>


            </div>

            <div class="collapse" :id="'collapse-' + index" :aria-labelledby="'heading-' + index"
              data-parent="#accordion">
              <div class="card-body">
                <iframe class="report-frame" :srcdoc="prepareSrcDoc(item.response)" sandbox="allow-same-origin"></iframe>
              </div>
            </div>
          </div>
        </div>


      </div>


    </main>
    <Modal :name="'prompt-modal'" :size="'60'" :max-width="'400'" :close="true">
      <LoadingSpinner v-if="loadingPrompt" />

      <div class="px-5" v-if="!loadingPrompt">
        <h2>Prompt:</h2>
        <div v-html="prompts"></div>

      </div>
    </Modal>
  </section>
</template>

<script>
import { bookersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState, mapActions } from "vuex";
import Modal from "@/components/Common/Modal.vue";
export default {
  name: "BookerDailyReport",
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
  },
  components: {
    LoadingSpinner,
    Modal
  },
  props: {
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loadingPrompt: false,
      prompts: '',
      loading: false,
      isMenuCollapse: false,
      reports: [
      ],
    };
  },
  created() {
    this.loading = true;
    this.getDailyReports()
  },

  methods: {
    showPrompt(date) {
      this.$modal.show("prompt-modal")
      this.loadingPrompt = true
      let params = {
        user_id: this.selectedUserId != null ? this.selectedUserId : this.currentUser.id,
        date_sintesis: date
      };
      bookersService.getPromptDaily(params).then((res) => {
        this.prompts = res.prompt;

        this.loadingPrompt = false
      })
    },
    getDailyReports() {
      console.log("Cargando reportes diarios para el booker:", this.selectedUserId != null ? this.selectedUserId : this.currentUser.id);
      bookersService.getBookerDailyReports(this.selectedUserId != null ? this.selectedUserId : this.currentUser.id)
        .then(response => {
          console.log("Reportes cargados:", response);
          this.reports = response;
          this.loading = false;
        })
        .catch(error => {
          console.error("Error al cargar los reportes:", error);
        });
    },

    prepareSrcDoc(html) {
      if (!html) return '';
      html = String(html).trim();

      // quitar envoltorios tipo ```html<br> ... <br>``` o variantes
      html = html
        .replace(/^```html<br\s*\/?>/i, '')
        .replace(/<br\s*\/?>```$/i, '')
        .replace(/^```|```$/g, ''); // por si solo vienen backticks
      html = html.replace(
        /^\s*(?:<p>)?\s*Voici le rapport structuré en HTML comme demandé\s*:?\s*(?:<\/p>)?\s*(?:<br\s*\/?>|\r?\n)*/i,
        ''
      );
      html = html.replace(
        /^\s*(?:<p>)?\s*Voici le rapport HTML structuré selon vos demandes\s*:?\s*(?:<\/p>)?\s*(?:<br\s*\/?>|\r?\n)*/i,
        ''
      ).replace(
        /^\s*(?:<p>)?\s*Voici le rapport structuré en HTML\s*:?\s*(?:<\/p>)?\s*(?:<br\s*\/?>|\r?\n)*/i,
        ''
      );
      // si no trae <html>, lo envolvemos para que el CSS funcione igual
      if (!/<html[\s>]/i.test(html)) {
        html = `<!doctype html><html><head><meta charset="utf-8"></head><body>${html}</body></html>`;
      }
      return html;
    },
  },

};
</script>
<style scoped>
.report-frame {
  width: 100%;
  height: 600px;
  border: 0;
  display: block;
}
</style>